import { defineNuxtPlugin } from '#app/nuxt'
import { LazyArticleCard, LazyBenefits, LazyButton, LazyCard, LazyDescriptionBlock, LazyEventCard, LazyEventsGrid, LazyGrid, LazyHeading, LazyImageBanner, LazyList, LazyListItem, LazyMultiColumnDescription, LazyMultiTabContent, LazyNewsGrid, LazyShortcutPills, LazySideBySide, LazyTeamsIntro, LazyVideoBanner, LazyWysiwyg, LazyContentHero, LazyHeroBanner, LazyArticlePage, LazyEventPage, LazyStaticPage, LazyTeamPage, LazyVacancyListPage, LazyVacancyPage, LazyVacancyPageTa, LazyNoVacancies, LazyTeams, LazyVacancyCard, LazyVacancyDisclaimer, LazyVacancyFilter, LazyVacancyFilterMultiselect, LazyVacancyForm, LazyVacancyFormExternal, LazyVacancyList, LazyVacancyRepresentative, LazyVacancySummary, LazyVacancySummaryTa } from '#components'
const lazyGlobalComponents = [
  ["ArticleCard", LazyArticleCard],
["Benefits", LazyBenefits],
["Button", LazyButton],
["Card", LazyCard],
["DescriptionBlock", LazyDescriptionBlock],
["EventCard", LazyEventCard],
["EventsGrid", LazyEventsGrid],
["Grid", LazyGrid],
["Heading", LazyHeading],
["ImageBanner", LazyImageBanner],
["List", LazyList],
["ListItem", LazyListItem],
["MultiColumnDescription", LazyMultiColumnDescription],
["MultiTabContent", LazyMultiTabContent],
["NewsGrid", LazyNewsGrid],
["ShortcutPills", LazyShortcutPills],
["SideBySide", LazySideBySide],
["TeamsIntro", LazyTeamsIntro],
["VideoBanner", LazyVideoBanner],
["Wysiwyg", LazyWysiwyg],
["ContentHero", LazyContentHero],
["HeroBanner", LazyHeroBanner],
["ArticlePage", LazyArticlePage],
["EventPage", LazyEventPage],
["StaticPage", LazyStaticPage],
["TeamPage", LazyTeamPage],
["VacancyListPage", LazyVacancyListPage],
["VacancyPage", LazyVacancyPage],
["VacancyPageTa", LazyVacancyPageTa],
["NoVacancies", LazyNoVacancies],
["Teams", LazyTeams],
["VacancyCard", LazyVacancyCard],
["VacancyDisclaimer", LazyVacancyDisclaimer],
["VacancyFilter", LazyVacancyFilter],
["VacancyFilterMultiselect", LazyVacancyFilterMultiselect],
["VacancyForm", LazyVacancyForm],
["VacancyFormExternal", LazyVacancyFormExternal],
["VacancyList", LazyVacancyList],
["VacancyRepresentative", LazyVacancyRepresentative],
["VacancySummary", LazyVacancySummary],
["VacancySummaryTa", LazyVacancySummaryTa]
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
